import { Signal } from "@suse-o11y/signal";
import React from "react";

import { isTruthy } from "~/tools/is-truthy";
import type { JSON } from "~/tools/json";
import { toJSON } from "~/tools/to-json";
import { usePermanent } from "~/tools/use-permanent";

import { ToggleListRootContextProvider } from "./_toggle-list-root-context";

export interface ToggleListRootProps {
	namespace?: JSON;
}

export const ToggleListRoot: React.FC<React.PropsWithChildren<ToggleListRootProps>> = ({ namespace, children }) => {
	const uniqId = React.useId();
	const rootNamespace = namespace == null ? uniqId : toJSON(namespace);
	const listNamespace = usePermanent(() => Signal(""));

	const compositeNamespace = React.useMemo(
		() =>
			Signal<string>(
				(monitor) => [rootNamespace, listNamespace.read(monitor)].filter(isTruthy).join("|"),
				listNamespace,
			),
		[rootNamespace, listNamespace],
	);

	return <ToggleListRootContextProvider value={compositeNamespace}>{children}</ToggleListRootContextProvider>;
};
